import React, {useState} from 'react';

import styles from './LoginWarning.module.css'
import {Button} from "../../ui/General/Button/Button.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import {LoginAndSignInPopup} from "../LoginAndSignInPopup/LoginAndSignInPopup.tsx";

export const LoginWarning: React.FC = () => {
    const {isMobile, isDesktop} = useScreenDetector()
    const [showLogin, setShowLogin] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);

    if(showLogin) return <LoginAndSignInPopup isOpen={true} close={() => setShowLogin(false)} isHasAccount={null} isSignedIn={false}/>
    if(showRegistration) return <LoginAndSignInPopup isOpen={true} close={() => setShowRegistration(false)} isHasAccount={false} isSignedIn={false}/>

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                Войдите или зарегистрируйтесь чтобы оформить заказ
            </div>
            <div className={styles.body}>
                <div className={styles.warning}>
                    Вы сможете отслеживать статус заказа и получать персональные предложения
                </div>
                <div className={styles.buttons}>
                    {isDesktop && (<>
                        <Button className={styles.btnLogIn} type='regular' onClick={() => setShowLogin(true)}>Вход</Button>
                        <Button className={styles.btnSignIn} type='regular' onClick={() => setShowRegistration(true)}>Регистрация</Button>
                    </>)}

                    {isMobile && (<>
                        <Button className={styles.btnLogInOrSignIn} type='regular' onClick={() => setShowLogin(true)}>Вход</Button>
                        <Button className={styles.btnLogInOrSignIn} type='regular' onClick={() => setShowRegistration(true)}>Регистрация</Button>
                    </>)}
                </div>
            </div>
        </div>
    );
};